function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import withGradient from '../../withGradient';
import { jsx as ___EmotionJSX } from "@emotion/core";

var Index = function Index(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 16 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      rest = _objectWithoutProperties(_ref, ["size", "color"]);

  return ___EmotionJSX("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 32 32"
  }, rest), rest.children, ___EmotionJSX("g", {
    fill: "none",
    fillRule: "evenodd"
  }, ___EmotionJSX("path", {
    fill: color,
    d: "M16,17.6658807 L23.0809938,10.586477 C23.8631387,9.80450766 25.1312463,9.80450766 25.9133913,10.586477 C26.6955362,11.3684464 26.6955362,12.6362692 25.9133913,13.4182385 L17.4161988,21.913523 C16.6340538,22.6954923 15.3659462,22.6954923 14.5838012,21.913523 L6.08660873,13.4182385 C5.30446376,12.6362692 5.30446376,11.3684464 6.08660873,10.586477 C6.8687537,9.80450766 8.13686126,9.80450766 8.91900624,10.586477 L16,17.6658807 Z"
  })));
};

export default withGradient(Index);